<script lang="ts">
  import MemberProfilePanel from "./MemberProfile.svelte";
  import LoadingMemberProfilePanel from "./LoadingMemberProfile.svelte";
  import { isMemberFetched } from "$stores/memberPanel";
</script>

{#if $isMemberFetched}
  <MemberProfilePanel />
{:else}
  <LoadingMemberProfilePanel />
{/if}
